/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";

const useClickOutside = (ref, callback) => {
	useEffect(() => {
		const handleClickOutside = event => ref.current && !ref.current.contains(event.target) && callback()
		document.addEventListener("mousedown", handleClickOutside)
		return () => { document.removeEventListener("mousedown", handleClickOutside) }
	}, [ref]);
}

export default useClickOutside